import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';

const styles = {
  container: {
    position: 'relative',
    width: '100%',
    height: '100vh',
    overflow: 'hidden',
  },
  iframe: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    border: 'none',
    margin: 0,
    padding: 0,
    overflow: 'hidden',
    zIndex: 0,
  },
};

const DOCS_BASE_URL = process.env.REACT_APP_GQL_DOCS_URL || 'http://localhost:3006';

// Module-level cache so the URL survives unmount/remount cycles
let cachedIframeSrc = null;
let cachedOrgId = null;
let buildInProgress = false;

const ApiDocsView = ({ currentUser }) => {
  const orgId = currentUser?.role?.org?.id || '';
  const [iframeSrc, setIframeSrc] = useState(() => {
    // If we already built a URL for this org, use it immediately
    if (cachedIframeSrc && cachedOrgId === orgId) return cachedIframeSrc;
    return null;
  });

  useEffect(() => {
    // Already have a cached URL for this org — use it
    if (cachedIframeSrc && cachedOrgId === orgId) {
      if (!iframeSrc) setIframeSrc(cachedIframeSrc);
      return;
    }

    // Another mount is already building the URL
    if (buildInProgress) return;

    let cancelled = false;
    buildInProgress = true;

    async function buildUrl() {
      try {
        const session = await Auth.currentSession();
        const token = session.getIdToken().getJwtToken();

        const url = new URL('/playground', DOCS_BASE_URL);
        url.searchParams.set('embedded', 'true');
        url.searchParams.set('token', token);
        url.searchParams.set('orgId', orgId);

        const fullUrl = url.toString();

        // Cache at module level
        cachedIframeSrc = fullUrl;
        cachedOrgId = orgId;
        buildInProgress = false;

        if (!cancelled) {
          setIframeSrc(fullUrl);
        }
      } catch (err) {
        buildInProgress = false;
        console.error('ApiDocsView: failed to get session', err);
      }
    }

    buildUrl();

    return () => {
      cancelled = true;
    };
  }, [iframeSrc, orgId]);

  if (!iframeSrc) {
    return null;
  }

  return (
    <div style={styles.container}>
      <iframe src={iframeSrc} style={styles.iframe} title="API Documentation" />
    </div>
  );
};

export default ApiDocsView;
